import {
    Directive,
    inject,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { AuthService } from '@webapp/auth/services/auth.service';

@Directive({
    selector: '[showForRole]',
    standalone: true,
})
export class ShowForRoleDirective implements OnInit {
    @Input('showForRole') roles: string[] = [];

    authService = inject(AuthService);
    private templateRef = inject(TemplateRef<unknown>);
    private viewContainer = inject(ViewContainerRef);

    ngOnInit(): void {
        const user = this.authService.user();
        this.viewContainer.clear();

        if (this.roles.includes(user?.role ?? '')) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
